import React, { useEffect, useRef } from 'react';
import DebounceInput from 'react-debounce-input';

/* Components */
import SearchResults from './SearchResults';

/* Utilities */
import { trans } from 'js/utilities';

export default function SearchOverlay({ results, query, isLoading, locale, updateQuery, closeSearch, resultsUrl }) {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current?.focus({preventScroll: true});
        }
    }, [inputRef]);

    return (
        <>
            <div className="search__overlay-input-wrapper mb-6">
                <DebounceInput
                    id="header-search-input"
                    inputRef={inputRef}
                    debounceTimeout={500}
                    type="text"
                    className="form-control form-control--search search__overlay-input"
                    value={query}
                    placeholder={trans('header.search.input.placeholder')}
                    onChange={(event) => updateQuery(event.target.value)}
                />
            </div>
            <div className="search__overlay-body">
                <SearchResults
                    results={results}
                    locale={locale}
                    resultsUrl={resultsUrl}
                />
            </div>
        </>
    );
}
